import { breakpoints, Modal } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ${Modal.Styled.ModalContainer} {
    width: 800px;
  }

  @media ${breakpoints['max-xs']} {
    ${Modal.Styled.ModalContainer} {
      width: 250px;
      min-width: 250px;
    }
  }
`;

export const Content = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
